exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "*{line-height:1.2;margin:0}html{color:#888;display:table;font-family:sans-serif;height:100%;text-align:center;width:100%}body{display:table-cell;vertical-align:middle;margin:2em auto}h1{color:#555;font-size:2em;font-weight:400}p{margin:0 auto;width:280px}pre{text-align:left;margin-top:32px;margin-top:2rem}@media only screen and (max-width:280px){body,p{width:95%}h1{font-size:1.5em;margin:0 0 .3em}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"camelCase":true,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:4]","minimize":true}!../~/postcss-loader?pack=default!./containers/notFoundPage/NotFoundPage.css
// module id = 267
// module chunks = 0